import { ColumnType, TableProps } from 'antd/es/table';
import { memo } from 'react';

import { Collapse } from 'components/Collapse/Collapse';
import TableComponent from 'components/Table/TableComponent';

export interface IPanelConfig<T = any> {
  title: string;
  key: string;
  columns: ColumnType<any>[];
  data: T[];
  tableProps?: TableProps;
}

interface ICollapse<T = any> {
  panels: IPanelConfig<T>[];
  tableProps?: TableProps;
  isShowLength?: boolean;
}

const CustomCollapse = ({
  panels,
  tableProps,
  isShowLength = true,
}: ICollapse) => {
  return (
    <Collapse
      defaultActiveKey={panels.map((panel) => panel.key)}
      items={panels.map((panel) => {
        return {
          key: panel.key,
          label: (
            <span className="font-bold text-xl">
              {panel.title} {isShowLength && `(${panel.data.length})`}
            </span>
          ),
          children: (
            <TableComponent
              rowKey={(record: any) => record?.id ?? ''}
              pagination={false}
              columns={panel.columns}
              dataSource={panel.data}
              scroll={{ x: 'max-content' }}
              {...tableProps}
              {...panel.tableProps}
            />
          ),
        };
      })}
    />
  );
};

export default memo(CustomCollapse);
